<div class="button button--block button--secondary-outline" (click)="btnClickOutput()">
  <span><mb-icon class="icon" icon="disney"></mb-icon></span>
  <ng-content select="[title]"></ng-content>
</div>
